import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index';
import request from '@/fly';
import Setting from '@/setting'
// 方法
import { includeArray } from '@/libs/system';
import common from './modules/common';
import homepage from './modules/homepage'
import feature from './modules/feature'


Vue.use(VueRouter)

/**
 * 在主框架内显示
 */

const frameIn = [{
        path: '/',
        redirect: {
            name: 'login'
        }
    },
    ...homepage,
    ...common,
    ...feature
];

/**
 * 在主框架之外显示
 */

const frameOut = [
    // 登录
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: () =>
            import ('@/views/login.vue')
    }
];

/**
 * 错误页面
 */

const errorPage = [{
        path: '/403',
        name: '403',
        meta: {
            title: '403'
        },
        component: () =>
            import ('@/views/error/403')
    },
    {
        path: '/500',
        name: '500',
        meta: {
            title: '500'
        },
        component: () =>
            import ('@/views/error/500')
    },
    {
        path: '*',
        name: '404',
        meta: {
            title: '404'
        },
        component: () =>
            import ('@/views/error/404')
    }
];

const routes = [
    ...frameIn,
    ...frameOut,
    ...errorPage
]

const router = new VueRouter({
    mode: Setting.routerMode,
    base: process.env.BASE_URL,
    routes
})

/**
 * 路由拦截
 * 权限验证
 */
let asyncRouter;

router.beforeEach((to, from, next) => {
    // 判断是否需要登录才可以进入
    if (to.matched.some(_ => _.meta.auth)) {
        // 这里依据 token 判断是否登录，可视情况修改
        const token = JSON.parse(localStorage.getItem('token'));
        const uuid = JSON.parse(localStorage.getItem('uuid'));
        const user = localStorage.getItem('USER');
        const userRouter = JSON.parse(localStorage.getItem('USER_ROUTER'));
        const userpermissions = JSON.parse(localStorage.getItem('USER_PERMISSIONS'));

        if (token && token !== 'undefined' && user && uuid && uuid !== 'undefined') {
            if (!asyncRouter) {
                if (!userRouter) {
                    request.get(`menu/${user.username}`).then((res) => {
                        asyncRouter = res.data
                        localStorage.setItem('USER_ROUTER', JSON.stringify(asyncRouter));
                    })
                } else {
                    store.commit('admin/menu/setSider', userRouter);
                }
            }
            if (userpermissions) {
                const isPermission = includeArray(to.meta.auth, userpermissions);
                if (isPermission) {
                    next();
                } else {
                    next({
                        name: '403'
                    });
                }
            } else {
                next({
                    name: 'login'
                });
            }
        } else {
            // 没有登录的时候跳转到登录界面
            // 携带上登陆成功之后需要跳转的页面完整路径
            next({
                name: 'login',
                query: {
                    redirect: to.fullPath
                }
            });
        }
    } else {
        // 不需要身份校验 直接通过
        next();
    }
});

export default router
